module.exports = __webpack_public_path__ + "static/media/device.e7131466.svg";